// extracted by mini-css-extract-plugin
export default {"emoji":"Emojis_emoji__uQqJp"};